import { filterOldProperties } from '@/utils/helpers'
import { initialConfig } from '@/utils/initialConfig'

const actions = {
  setConfigs({ state, commit }, configs) {
    const newConfig = {
      ...state.config,
      ...filterOldProperties(configs)
    }
    commit('setConfigs', newConfig)
    commit('reloadCashierMutation')
  },
  overrwriteConfigs({ commit, rootState }, configs) {
    const isDefaultPreset = rootState.config.preset === 'Default'
    const merchantId = localStorage.getItem('merchantId')
    const userId = localStorage.getItem('userId')

    const newConfig = {
      ...initialConfig(),
      ...filterOldProperties(configs),
      ...(isDefaultPreset && {
        ...(merchantId && { merchantId }),
        ...(userId && { userId })
      })
    }
    commit('setConfigs', newConfig)
    commit('reloadCashierMutation')
  }
}

export default actions
